import { BlocCoordinator } from "@lib/bloc/BlocCoordinator"
import { ServiceItemForm } from "@model/serviceRequests/ServiceItemForm"
import { labelForServiceCode } from "@model/serviceRequests/ServiceRequest"
import { CompanyBloc } from "@state/company/CompanyBloc"
import {
    AddExistingServiceItemsDialogBloc,
    AddExistingServiceItemsDialogState,
} from "@state/workRequests/AddExistingServiceItemsDialogBloc"

export class AddExistingServiceItemsDialogViewModel extends BlocCoordinator<
    [AddExistingServiceItemsDialogState],
    AddExistingServiceItemsDialogState
> {
    constructor(private bloc: AddExistingServiceItemsDialogBloc, private companyBloc: CompanyBloc) {
        super([bloc])
    }

    protected transform = ([state]: [AddExistingServiceItemsDialogState]) => state

    load = (assetId: number) => this.bloc.load(assetId)

    close = () => this.bloc.close()

    selectItem = async (item: ServiceItemForm, onSelected: (item: ServiceItemForm) => void) =>
        await this.bloc.selectItem(item, onSelected)

    getCode(serviceCodeId?: number | null): string {
        if (serviceCodeId) {
            const serviceCodes = this.companyBloc.state.serviceCodes;
            if (!serviceCodes) return "-";

            const sc = serviceCodes[serviceCodeId];
            if (!sc) return "-";

            return labelForServiceCode(sc);
        }
        else {
            return "-";
        }
    }
}
